import axios from '@axios';

const base = '/api/v1/prison-users';

export default {
  login(username, password) {
    return axios.post(`${base}/tokens`, { username, password });
  },
  getUser() {
    return axios.get(`${base}/user`);
  },
  Authorise(otp) {
    return axios.post(`${base}/two-factor/authorise`, { otp });
  },
  getOTP(visitId) {
    return axios.get(`${base}/otp/recording-and-audit-trail/${visitId}`);
  },
  changePassword(currentPassword, newPassword) {
    return axios.post(`${base}/change-password`, { currentPassword, newPassword });
  },
};
